/* eslint-disable */


import React, { useEffect, useState } from "react";

import { Link as RouterLink, useSearchParams, useParams, useNavigate, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, Typography, Container,
} from '@mui/material';

import { makeStyles } from '@mui/styles';


// components
import Page from '../components/Page';
import SoundBoxDevicesListBuilder from './SoundBoxDeviceListBuilder';
import { useAuth } from "../components/customContextProviders/AuthContext";
import { GetAllDevicesWithTrans } from "../network/Device";
import AlertDialog from "../components/AlertDialog";
import { DeviceOrderdButtons } from "src/components/_dashboard/soundbox";
import {parseValidationErrorMessage} from '../utils/Utilities'


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const useStyles = makeStyles({
  
  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    maxHeight:'800px',
    marginRight: "3px",
    width: "100%",
    minWidth: "100%",
   
  },
  backGroundRed:{
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite:{
    background:'white'
  }
});




export default function SoundBoxDevices() {

  const location=useLocation()
  const {sessionUserData}=useAuth()
  const [devicesList, setDevicesList] = useState([]);
  const classes=useStyles();

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });




  function fetchDevices(organizationId) {

    
    GetAllDevicesWithTrans(1,10,organizationId,"","","").then((res)=>{
      setDevicesList(res?.data?.data?.lists)
    }).catch((error)=>{
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error), title: "Failed to fetch devices", btnLabel: "OK" });
      setOpenAlertDialog(true)
    })
  }

  

  return (
    <Page title="Devices">
     
        <Box >
          <Typography variant="h4" sx={{p:2,pl:3}}>
          {location?.state?.organizationData?.name}  Devices
          </Typography>
        </Box>
        
        <Container maxWidth="false">
        <DeviceOrderdButtons/>
        <SoundBoxDevicesListBuilder soundboxDeviceListData={devicesList}/>
        {/* <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={9}>
          <SoundBoxDevicesListBuilder soundboxDeviceListData={devicesList}/>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Card className={classes?.cardWithBorder}   sx={{ height: "100%", }}>
              <Box sx={{mt:2,}}>
                     <Typography sx={{p:2, fontWeight: 700,mb:2, fontSize: "18px", lineHeight: "23px", color: "#171D40" }}>Notifications</Typography>

                    {devicesList?.filter(obj => obj?.status==="OFFLINE" || obj?.status===undefined).map((item, index) => (
                           <Box sx={{mb:2,p:1,display:'flex'}}
                           className={index===0 ? classes?.backGroundRed:classes?.backGroundWhite}
                           >
                              <Box sx={{width:'40%'}}>
                             <RouterLink
                              to="/dashboard/soundboxdevicedetails"
                              state={{ deviceId: item?.id }} >
                             <Typography sx={{textAlign:'left',fontSize:12}}>{crossMarkString(item?.merchantId)}</Typography>
                           </RouterLink>
                           </Box>
                            <Typography sx={{textAlign:'right',width:'60%',fontSize:12}}>Last online {fToNow (convertUTCDateStringToLocal(item?.last_updated_time))}</Typography>
                           </Box>

                       ))}
                   </Box>
              </Card>
        </Grid>
          </Grid> */}
        </Container>
     
        <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title} 
          btnLabel={alertDialogMetas?.btnLabel}  handleClose={()=>setOpenAlertDialog(false)} />

    </Page>
  );
}
